import type { FC } from 'react'

import { useSingleContentDownloadPageQuery } from '@segment/api/routes/template/queries'

import ContentDownload from './components/ContentDownload'

interface ContentDownloadPageViewProps {
  slug: string
}

const ContentDownloadPageView: FC<ContentDownloadPageViewProps> = ({ slug }) => {
  const { data } = useSingleContentDownloadPageQuery({ args: [slug] })

  return <ContentDownload data={data} />
}

export default ContentDownloadPageView
